import TentangAplikasiApp from 'app/TentangAplikasiPage/pages/TentangAplikasi'
import { Header } from 'app/TentangAplikasiPage/components/Header'

export default function TentangAplikasiPage() {
  return <TentangAplikasiApp />
}

TentangAplikasiPage.layoutOpts = {
  hasBottomNav: false,
  hasHeader: true,
  header: Header,
}
